import VideoSnapshot from 'video-snapshot';

export const createSnapshot = async (file: File) => {
  const snapshoter = new VideoSnapshot(file);
  return await snapshoter.takeSnapshot();
};

export const createSnapshotAsFile = async (file: File) => {
  const fetchResult = await fetch(await createSnapshot(file));
  return new File(
    [await fetchResult.blob()],
    `${file.name}_snapshot_${Math.round(Math.random() * 9999999)}`,
    {
      type: 'image/png',
    },
  );
};
